import { Routes } from "@angular/router";
import { AuthGuard } from "../app-auth/guards/auth.guard";
import { LoginGeneralComponent } from "../app-auth/login/login-general/login-general.component";
import { EnvInitializer } from "../common/services/environement.initializer";
import { LoginInitializer } from "../common/services/login.initializer";
import { LicenseGuard } from "./license/license.guard";
import { LicenseNotFoundComponent } from "./license/license.no.found/license.not.found.component";
var defaultRoute = 'selfscheduling';
var ɵ0 = function () { return import("./../app-main/self.scheduling/self.scheduling.module.ngfactory").then(function (mod) { return mod.SelfSchedulingModuleNgFactory; }); };
var routes = [{
        path: '',
        pathMatch: 'full',
        redirectTo: defaultRoute
    },
    {
        path: 'login',
        component: LoginGeneralComponent,
        canActivate: [LicenseGuard],
        resolve: {
            initData: LoginInitializer
        }
    },
    {
        path: 'selfscheduling',
        loadChildren: ɵ0,
        canActivate: [AuthGuard],
        resolve: {
            initData: EnvInitializer
        }
    },
    {
        path: 'licensenotfound',
        component: LicenseNotFoundComponent
    },
    // otherwise redirect to home
    { path: '**', redirectTo: '' }];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
export { ɵ0 };
